module.exports = __webpack_public_path__ + "img/52002769_L.934cedc2.png";